import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCloseOldModal } from '../../../../store/modal/modalHooks';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import SupportSuccessMessageContent from '../SupportSuccessMessageContent';

interface SupportSuccessMessageInterface {
  serviceCallId: number;
}

const SupportSuccessMessage = ({
  serviceCallId,
}: SupportSuccessMessageInterface) => {
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();

  return (
    <div className="support-success-message">
      <ModalHeader>
        <p className="form-header-title" style={{ marginBottom: '50px' }}>
          {t('CREATE_NEW_SERVICE_CALL_TITLE')}
        </p>
      </ModalHeader>
      <>
        <SupportSuccessMessageContent serviceCallId={serviceCallId} />
      </>
      <ModalFooter className="add-category-modal-buttons">
        <Button type="button" color="primary" onClick={closeModal}>
          {t('CREATE_NEW_SERVICE_CALL_CLOSE_BUTTON')}
        </Button>{' '}
      </ModalFooter>
    </div>
  );
};

export default SupportSuccessMessage;
